import { render, staticRenderFns } from "./CodeUret.vue?vue&type=template&id=6228f412"
import script from "./CodeUret.vue?vue&type=script&lang=js"
export * from "./CodeUret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports